<template>
  <div class="Notice">
    <div>{{ propsContent.content }}</div>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" type="primary" @click="closeDialog">
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  props: {
    propsContent: {
      default: Object,
      type: Object
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}
</style>
